import {Directive, ElementRef, HostBinding, HostListener, Input} from '@angular/core';

@Directive({
    selector: '[expandToggle]',
  standalone: false
})
export class ExpandToggleDirective {

    @Input('expandToggle') expansionPanelRef?: HTMLDivElement;
    @Input() secondBoolean: boolean | undefined;

    @HostBinding('class.open') isOpen = false;

    currentClasses = '';

    constructor(private elRef: ElementRef) {
    }

    @HostListener('click', ['$event']) toggleOpen(event: Event) {
        this.isOpen = this.elRef.nativeElement.contains(event.target) ? !this.isOpen : false;
        if ((this.secondBoolean && this.expansionPanelRef?.classList.contains('open'))){
            return
        }
        this.expansionPanelRef?.classList.toggle('open');
    }
} 